import React from 'react';
import { useTranslation } from '@pascal/pascal-core';

export const FavoriteBetsHeader = ({setIsShowBetActionModal}) => {
  const t = useTranslation();

  return(
    <div className="r-a-p-header">
      <div className="r-a-p-header-inner">
        <div className="r-close-btn" onClick={() => setIsShowBetActionModal(false)}>
          <i className="icon-close"/>
        </div>
        <p className="r-a-p-heading">{t('FAVORITE_BETS')}</p>
      </div>
    </div>
  )
}
